export function delayToColor(delay) {
  if (!delay) return "gray";
  if (delay < 15) return "success";
  if (delay < 45) return "warning";

  return "error";
}

export function delay(place) {
  if (!place.waitingList) return null;
  return (
    place.waitingList.averageWaitingTimePerPerson *
    place.waitingList.currentlyWaiting
  );
}

export function waitToColor(place) {
  if (!place.waitingList || place.waitingList.status == "closed") return "gray";

  if (place.waitingList.currentlyWaiting < 4) return "success";
  if (place.waitingList.currentlyWaiting < 7) return "warning";

  return "error";
}

export function formatWaitTime(esistimatedArrivalDate) {
  if (!esistimatedArrivalDate) return "0 minuti";

  esistimatedArrivalDate = new Date(esistimatedArrivalDate);
  const diff_min = Math.round(
    (esistimatedArrivalDate - new Date()) / 1000 / 60
  );

  if (diff_min < 0) return "0 minuti";
  if (diff_min < 60) return `${diff_min} minuti`;

  return `${Math.floor(diff_min / 60)} ore e ${diff_min % 60} minuti`;
}
